(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfSlider', [
    '$parse', function($parse) {
      return {
        restrict: 'A',
        scope: {
          ngModel: '=ngModel'
        },
        link: (function(_this) {
          return function(scope, element, attrs) {
            var opts, slideEventHandler, sliderOpts;
            slideEventHandler = null;
            sliderOpts = attrs.mfSlider;
            opts = $parse(sliderOpts)(scope);
            element.slider(opts != null ? opts : {});
            if (attrs.mfSliderDisable != null) {
              scope.$parent.$watch(attrs.mfSliderDisable, function(value) {
                if (value) {
                  return element.slider('disable');
                } else {
                  return element.slider('enable');
                }
              });
            }
            element.on('slide', function(event, ui) {
              scope.ngModel = ui.value;
              scope.$apply();
              return typeof slideEventHandler === "function" ? slideEventHandler(event, ui) : void 0;
            });
            scope.$watch(scope.ngModel, function(value) {
              if (value === void 0) {
                return;
              }
              return element.slider('value', value);
            });
            if (scope.ngModel !== void 0) {
              element.slider('value', scope.ngModel);
            }
            scope.$parent.$watch(attrs.mfSliderOnslide, function(callback) {
              return slideEventHandler = callback;
            });
            return scope.$on('$destroy', function() {
              return element.slider('destroy');
            });
          };
        })(this)
      };
    }
  ]);

}).call(this);
